export const environment = {
  production: true,
  apiUrl: 'https://stage.pharmigo.co/api',
  googleMapsApiKey: 'AIzaSyCuvE2xyxE5jSTrOmUIcPiJ70bsoW1oPZs',
  // URL of the full authenticated app — used after login to redirect user
  appUrl: 'https://stage.pharmigo.co',
  publicUrl: '',
};
